<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
    >
      <el-form-item label="商品名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="商品库存" prop="goods_num">
        <el-input v-model="form.goods_num"></el-input>
      </el-form-item>
      <el-form-item label="现价" prop="present_price">
        <el-input v-model="form.present_price"></el-input>
      </el-form-item>
      <el-form-item label="原价" prop="original_price">
        <el-input v-model="form.original_price"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        <el-button @click="close(2)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import carSearch from "../../components/car-search/car-search";
export default {
  name: "car-special-offer-form",
  components: {
    carSearch,
  },
  props: {
    layerid: String,
    edit: Boolean,
    seriesid: Number,
    row: {
      default: function () {
        return [];
      },
    },
  },
  data() {
    let data = {
      form: {
        name: "",
        goods_num: "",
        present_price: "",
        original_price: "",
        status: "",
      },
      loading: false,
      rules: {
        name: [
          { required: true, message: "请填写商品名称", trigger: "change" },
        ],
        goods_num: [
          { required: true, message: "请填写商品库存", trigger: "blur" },
        ],
        present_price: [
          { required: true, message: "填写现价", trigger: "blur" },
        ],
        original_price: [
          { required: true, message: "填写原价", trigger: "blur" },
        ],
        status: [
          { required: true, message: "选择商品状态", trigger: "change" },
        ],
      },
      options: [
        {
          value: '1',
          label: '在售'
        }, {
          value: '2',
          label: '已下架'
        }, {
          value: '3',
          label: '待审核'
        }, {
          value: '4',
          label: '驳回'
        }
      ],
    };
    return data;
  },
  mounted() {
    if (this.seriesid) this.form.seriesid = this.seriesid;
    if (this.edit) {
      this.form = this.row;
      if(this.form.status == 1){
        this.form.status = "在售"
      }else if(this.form.status == 2){
        this.form.status = "已下架"
      }else if(this.form.status == 3){
        this.form.status = "待审核"
      }else if(this.form.status == 4){
        this.form.status = "驳回"
      }
    }
  },
  methods: {
    onSubmit() {
      if(this.form.status == "在售"){
        this.form.status = 1
      }else if(this.form.status == "已下架"){
        this.form.status = 2
      }else if(this.form.status == "待审核"){
        this.form.status = 3
      }else if(this.form.status == "驳回"){
        this.form.status = 4
      }
      let data = this.form;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("emincarofer", { form: data });
        } else {
          this.$message.error("请检查表单完整性");
          return false;
        }
      });
    },
    close() {
      this.$emit("emincarofer", {});
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
<style>
.el-cascader--small {
  width: 100% !important;
}
</style>
